module.exports = __webpack_public_path__ + "static/img/donggua.0d558db8.png";